import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

var AppointmentTypeToolTip = (_param)=>{
    var { className , tabIndex =0  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "tabIndex"
    ]);
    return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-tooltip', className),
        role: "button",
        tabIndex: tabIndex
    }), /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-tooltip__icon-container"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "info"
    })));
};

export { AppointmentTypeToolTip, AppointmentTypeToolTip as default };
//# sourceMappingURL=AppointmentTypeToolTip.js.map
